export default function FilterPillGroup({
  options = [],
  value,
  onChange,
  label,
  className = "",
  testIdPrefix = "",
}) {
  return (
    <div
      className={`d-flex flex-wrap gap-2 ${className}`}
      role="radiogroup"
      aria-label={label}
      data-testid={`${testIdPrefix}filter-pill-group`}
    >
      {options.map(option => {
        const selected = option.value === value;

        return (
          <button
            key={option.value}
            type="button"
            role="radio"
            aria-checked={selected}
            className={`statistic-chooseable-badge ${selected ? "active" : ""} ${option.disabled ? "disabled" : ""}`}
            disabled={option.disabled}
            onClick={() => onChange(option.value)}
            data-testid={`${testIdPrefix}filter-pill-${option.value}`}
          >
            {option.label}
          </button>
        );
      })}
    </div>
  );
}
